import { defineMessages } from 'react-intl';

export const profileInfosMessages = defineMessages({
  missingProfile: {
    defaultMessage: 'The user does not exist or has not been found.',
    id: 'rV0i46',
  },
  missingBio: {
    defaultMessage: 'The user has not yet provided their biography.',
    id: 'lVAFh5',
  },
  inscriptionDate: { defaultMessage: 'Registered since {createdAt, date, short}', id: '4bsOD6' },
  inscriptionDateUnknown: { defaultMessage: 'Unknown registration date', id: 'TDdofj' },
  messagesCount: {
    defaultMessage: `{count,plural,=0{0 messages} =1{1 message} other{# messages}}`,
    id: 'Kf289b',
  },
  voteSendedCount: {
    defaultMessage: `{count,plural,=0{0 votes} =1{1 vote} other{# votes}}`,
    id: 'aDzkIP',
  },
  voteReveivedCount: {
    defaultMessage: `{count,plural,=0{0 votes received} =1{1 vote received} other{# votes received}}`,
    id: 'U5dudJ',
  },
});
